import { Link, LinkProps, useRouteMatch } from "react-router-dom";

import { cx } from "@/utils";

import styles from "./Tabs.module.css";

const TabLink: React.FunctionComponent<LinkProps & { to: string }> = ({
  children,
  className,
  to,
  ...rest
}) => {
  const active = useRouteMatch(to)?.isExact;

  return (
    <Link
      to={to}
      className={cx(styles.heading, className, { [styles.active]: active })}
      {...rest}
    >
      {children}
    </Link>
  );
};

export default TabLink;
